<template>
  <v-tooltip
    :location="location"
    :open-on-click="openOnClick"
    :open-on-hover="!openOnClick"
  >
    <template #activator="{ props }">
      <v-icon
        v-bind="props"
        :aria-label="$bct(ariaLabel || text)"
        :class="{
          'material-icons-outlined': iconStyle === 'outlined',
          'material-icons-round': iconStyle === 'round',
        }"
        :color="color"
        :icon="icon"
        :size="size"
        aria-hidden="false"
        class="focus-visible"
        role="tooltip"
        tabindex="0"
      />
    </template>

    <slot>
      <span>
        {{ $bct(text) }}
      </span>
    </slot>
  </v-tooltip>
</template>

<script setup>
const $bct = inject('translator');

defineProps({
  ariaLabel: {
    type: String,
    default: null,
  },
  color: {
    type: String,
    default: 'black',
  },
  icon: {
    type: String,
    required: true,
  },
  iconStyle: {
    type: String,
    default: 'outlined',
  },
  location: {
    type: String,
    default: 'bottom',
  },
  openOnClick: {
    type: Boolean,
    default: false,
  },
  size: {
    type: String,
    default: '24',
  },
  text: {
    type: String,
    default: '',
  },
});
</script>
